import { Handle, Position } from "reactflow"
import Icon from 'src/@core/components/icon'

import { Box } from "@mui/material"
import { CustomNodeProperties } from "../types/types"

import '../styles/nodo-accion-de-retorno.styles.css'

const NodoAccionDeRetorno = (props: CustomNodeProperties) => {

    // Los id de los handle de salida son el sinValor de la tabla tblAccionValor

    props.data.label = props.data.label

    return (
        <>
            <Handle
                type='source'
                id='in'
                position={Position.Left}
            />
            <div className="nodo-retorno">
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <Icon
                        height={'100%'}
                        icon={'humbleicons:arrow-go-back'} />
                </Box>
            </div >
            <Handle
                type='target'
                id='1'
                position={Position.Right}
            />
        </>
    )
}

export default NodoAccionDeRetorno
